import React, { useState, useEffect } from 'react';

import {
  ActivityIndicator,
  Image, ImageBackground, ScrollView, View,
} from 'react-native';
import { Colors } from 'react-native-paper';
import leths_back from '../../../assets/images/leths_back.png';
import { appColors } from '../../../assets/styles/global';
import { AppHeader } from '../../../components/common';
import { AppText } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { API } from '../../../service/api';
import styles from './styles';

const Benefits = () => {
  const [cupoms, setCupoms] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    API.post('/search/beneficio', {
      where: '',
      orderby: 'validade desc',
      limit: 100,
      offset: 0,
    }).then((result) => {
      const data = result.data.data.map((benefit) => ({
        cupomkey: benefit.titulo,
        value: benefit.valor,
        description: benefit.descricao,
        validDate: new Date(benefit.validade).toLocaleDateString(),
        logo: benefit.imagem,
        color: benefit.cor,
      }));
      setCupoms(data);
      setLoading(false);
    });
  }, []);

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title="Benefícios" />
      <View style={styles.content}>
        {loading ? <ActivityIndicator size="large" color={appColors.primary} />
          : (
            <ScrollView style={{ paddingBottom: pixelDimensions(10) }}>
              {
                        !!cupoms.length
                        && cupoms.map(({
                          cupomkey, description, type, validDate, value, logo, color,
                        }) => (
                          <View key={cupomkey} style={styles.viewCoupom}>
                            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                              <Image source={logo} style={{ width: pixelDimensions(20), height: pixelDimensions(20), borderRadius: pixelDimensions(50) }} />
                            </View>
                            <View style={{ flex: 1 }}>
                              <View style={{
                                backgroundColor: color, paddingVertical: pixelDimensions(1), borderTopRightRadius: pixelDimensions(2), alignItems: 'center',
                              }}
                              >
                                <AppText size="bold" style={{ color: Colors.white, fontSize: pixelDimensions(4.5) }}>
                                  #
                                  {cupomkey}
                                </AppText>
                              </View>
                              <View style={{
                                flexDirection: 'row', padding: pixelDimensions(2), justifyContent: 'center', alignItems: 'center',
                              }}
                              >
                                <AppText
                                  size="bold"
                                  style={{
                                    flex: 1, fontSize: pixelDimensions(5), color: Colors.indigo700, textAlign: 'center',
                                  }}
                                >
                                  {`${type === 'R$' ? type : ''} ${value}${type === '%' ? type : ''}`}
                                </AppText>
                                <AppText
                                  style={{
                                    flex: 3, paddingLeft: pixelDimensions(2), textAlign: 'justify', fontSize: pixelDimensions(3),
                                  }}
                                  numberOfLines={3}
                                >
                                  {description}
                                </AppText>
                              </View>
                              <View style={{ alignItems: 'flex-end', paddingHorizontal: pixelDimensions(2), paddingBottom: pixelDimensions(1) }}>
                                <AppText size="bold" style={{ color: Colors.grey500, fontSize: pixelDimensions(3) }}>
                                  Válido até
                                  {' '}
                                  {validDate}
                                </AppText>
                              </View>
                            </View>
                          </View>
                        ))
                    }
            </ScrollView>
          )}
      </View>
    </ImageBackground>
  );
};

export default Benefits;
